export interface RoleOption {
  value: string;
  label: string;
}

/**
 * Sentinel value used in the Role Select to reveal a free-text input
 * that lets the user type a custom relationship role. Anything other
 * than this sentinel is sent verbatim as `users.role`.
 */
export const CUSTOM_ROLE_SENTINEL = '__custom__';

/** Canonical role picker options — used by onboarding and Settings. */
export const ROLE_OPTIONS: RoleOption[] = [
  { value: 'Mom', label: 'Mom' },
  { value: 'Dad', label: 'Dad' },
  { value: 'Guardian', label: 'Guardian' },
  { value: 'Caregiver', label: 'Caregiver' },
  { value: 'Stepdad', label: 'Stepdad' },
  { value: 'Stepmom', label: 'Stepmom' },
  { value: CUSTOM_ROLE_SENTINEL, label: '+ Type my own...' },
];

/**
 * A role persisted under a prior list (e.g. "Grandparent", "Aunt",
 * "Uncle", "Other", or any custom text) may not match any current
 * option. Callers that render the Select should pass the persisted
 * value through this helper to decide whether to show it in the
 * dropdown as a one-off option or route to the custom input.
 */
export function isKnownRoleValue(value: string): boolean {
  return ROLE_OPTIONS.some(
    (o) => o.value !== CUSTOM_ROLE_SENTINEL && o.value === value,
  );
}
